<template>
<div class="">
  <div class="gPageBorder">

    <eqdia :config='econfig'></eqdia>

    <!-- <el-dialog :title="$t('app_preview')" :visible.sync="viewPic">
      <img :src='vurl' style="width:80%;background: red;margin-left:10%;">
    </el-dialog> -->

		<el-row :gutter="10" class='gTopMg' style="margin-bottom: 20px;padding:0 20px 0 20px;">
      <el-col :span="8">
        <el-button type='primary'  @click="showEQ">{{$t('app_eqcapture')}}</el-button>
      </el-col>
      <el-col :span="4" :offset='8'>
        <div class=''>
          <MechanismSelector style='width:100%;' :data="mechanismData"></MechanismSelector>
        </div>
      </el-col>
      <el-col :span="4" style="">
        <el-input
          :placeholder="$t('lin_global.label_no')"
          icon="search"
          v-model="queryCondition.terminal_no"
          :on-icon-click="handleIconClick"
          @keyup.enter.native="focusEvent(handleIconClick)">
        </el-input>
      </el-col>

			  <!-- <el-col :span="2">
					<el-button type="primary" @click="search" style="width:100%" >{{$t('lin_btn.check')}}</el-button>
				</el-col>
				<el-col :span="2">
					<el-button @click="reset" style="width:100%" >{{$t('lin_btn.reset')}}</el-button>
				</el-col>
				<el-col :span="3">
					<el-button @click="catchLog" type='primary' style="width:100%" >{{$t('app_catchlog')}}</el-button>
				</el-col> -->
	  </el-row>
	<el-table v-loading="loading" :element-loading-text="$t('lin_global.loading')" :data="tableData" id="tableData" border style="width:100%">
    <el-table-column prop="terminalNo" :label="$t('app_deviceNo')" :show-overflow-tooltip="true"></el-table-column>
    <el-table-column prop="terminalName" :label="$t('app_deviceName')" :show-overflow-tooltip="true"></el-table-column>
    <el-table-column prop="mechname" :label="$t('app_distributor')" :show-overflow-tooltip="true"></el-table-column>
    <el-table-column prop="optTime" :label="$t('app_cpttime')" :show-overflow-tooltip="true"></el-table-column>
    <el-table-column prop="status" :label="$t('lin_global.status')" :formatter="formatStatus" :show-overflow-tooltip="true" width="150"></el-table-column>
    <el-table-column
      :label="$t('lin_global.ope')" width="110">
      <template slot-scope="scope">

			<el-tooltip class="item"  effect="dark" :content="$t('app_view')" placement="top">
          <el-button :disabled="scope.row.status != 2" type='text'  @click="viewRow(scope.row)"><i class="fa fa-file-image-o" ></i></el-button>
			</el-tooltip>

			&nbsp;

			<el-tooltip class="item"  effect="dark" :content="$t('lin_btn.delete')" placement="top">
				<el-button type='text'  @click="delRow(scope.row)"><i class="fa fa-trash-o" style="color:#FF4949"></i></el-button>
			</el-tooltip>

      </template>
    </el-table-column>
    </el-table>
    <div v-if="total > 0" class="  gPgDiv " id="pagination" style="">
      <el-pagination class='gPg' style='float:right;' @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page" :page-sizes="$gRows"
        :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
  </div>
</div>
</template>
<script>
import axios from 'axios'
import eqdia from './eqdia'
import MechanismSelector from '@/components/global/mechanism_selector.vue'
import { baseurl,focusEvent,url,urlAssets } from '../../api/url'
export default{
		computed: {
		},
		components: {
      MechanismSelector,eqdia
		},
		name:'log',
		data () {
			var that = this
			return{
        vurl: '',
        viewPic: false,
				baseUrl:urlAssets.prefix,
				focusEvent: focusEvent,
				areaList1: [],
				value1: '',
				input1:'',
        mech: '',
        econfig: {},
        mechanismData: {
          callback (value) {
            that.mech = value
            that.getLog()
          }
        },
				queryCondition: {
					'terminal_no': '',
					'terminal_name': '',
					'terminal_log_type': '',
					'areaid': '',
					'start_time': '',
					'end_time': ''
				},
				loading: false,
				page: 1,
				total: 0,
				tableData: [],
        pip: 'szzt',
        pcode: 'szzt'
			}

		},
		created () {
			this.getLog()
		},
		destroyed () {
		  clearInterval(window.logTm)
		},
		methods:{
      showEQ () {
        var _this = this
        this.econfig = {
          callback: true,
          close: (row) => {
            var no = row.terminalNo
            if (no) {
              _this.loading = true
              _this.sCapture(no, res => {
                _this.loading = false
                if (res.status === 200) {
                  _this.$message.success(res.message)
                  _this.getLog()
                } else {
                	_this.$message.error(res.message)
                }
              }, ()=> {
                _this.loading = false
              })
            }
          }
        }
      },
			upadteData () {
				var isUpdate = false
				this.tableData.forEach((vl) => {
					if (vl.status == '1') {
						isUpdate = true
						return
					}
				})
				if (isUpdate) {
					var _this = this
					window.logTm = setTimeout(() => {
						_this.getLog()
					}, 3000)
				}
			},
			terlogOperate (type, row) {
				var logId = type == '2'? row.id : ''
				this.loading = true
				this.$operateTerLog(type, logId, row.terminalNo, (res) => {
				  this.loading = false
				  if (res.status === 200) {
					this.$message.success(res.message)
					this.getLog()
				  } else {
					this.$message.error(res.message)
				  }
				}, (error) => {
				  this.loading = false
				  this.$message.error(res.message)
				})
			},
			downUrl (tail) {
				// return this.pip + tail
        return this.$host + tail
			},
			getChannel () {

				// this.$getChannelList(this.pcode, this.pip, 999, 1, '', (res) => {
				// 	if (res.status === 200) {
		  //   		this.areaList1 = res.data;
				// 	} else {
				// 		this.$message.error(res.message)
				// 	}
				// }, () => {
				// 	this.$message.error(this.$t('app_rqsError'))
				// })
			},
			getLog () {
        clearTimeout(window.logTm)
				// this.loading = 1
				var tNo = this.queryCondition.terminal_no
				var mech = this.mech
				// var bgTime = this.queryCondition.start_time
				// var endTime = this.queryCondition.end_time
        this.getSCapture(this.page, this.$gRow, tNo, mech, (res) => {
						this.loading = 0
						if (res.status === 200) {
							this.tableData = res.data
							this.total = res.total
							this.upadteData()
						} else {
							this.$message.error(res.message)
						}

				  }, (err) => {
								this.$message.error(this.$t('app_rqsError'))
								this.loading = 0
				})
			},
			catchLog () {

			},
      viewRow (row) {
        this.vurl = this.$host + row.imgUrl
        window.open(this.vurl,'_blank')
      },
			delRow (row) {
				this.$confirm(this.$t("app_tipAppEdit"), this.$t('lin_btn.tips'), {
				  confirmButtonText: this.$t('lin_btn.confirm'),
				  cancelButtonText: this.$t('lin_btn.cancel'),
				  type: 'warning'
				}).then(() => {
						this.loading = true

            this.$delsCapture(row.id, (res) => {
								this.loading = false
								if (res.status === 200) {
									this.$message.success(res.message)
									this.getLog()
								} else {
									this.$message.error(res.message)
								}
							}, (err) => {
								this.$message.error(this.$t('app_rqsError'))
								this.loading = false
						})
				}).catch(() => {
				})
			},
			dataChange:function(value){
				this.queryCondition.start_time = value?value:'';
				this.getLog()
			},
			dataChange1:function(value){
				this.queryCondition.end_time = value?value:''
				this.getLog()
			},
			reset(){
			},
			statusChange(){
				this.getLog()
			},
			handleIconClick:function(){
				this.getLog()
			},
			formatStatus:function(row,column){
					// return row.status == 0?this.$t('lin_global.ddsc'):row.status == 1?this.$t('lin_global.scz'):row.status == 2?this.$t('lin_global.sccg'):row.status == 3?this.$t('lin_global.scsb'):'';
          var data = {
            '0': this.$t('app_catching'),
            '1': this.$t('app_ulding'),
            '2': this.$t('app_ulyet'),
            '3': this.$t('lin_global.scsb'),
          }
          return data[row.status]
		  },
		  search:function(){
		    	this.getLog(1,this.queryCondition.terminal_no,this.queryCondition.areaid,this.queryCondition.start_time,this.queryCondition.end_time);
		  },

			handleSizeChange: function (val) {
		    this.$gRow = val
			},
			handleCurrentChange: function (val) {
					this.page = val
					this.getLog()
			}

		}
	}
</script>



// WEBPACK FOOTER //
// scapture.vue?beb94682